module.exports = __webpack_public_path__ + "static/media/empty_resources.d54674f8.png";